import { useMemo } from 'react';
import { useUserContext } from 'src/contexts/UserContext';
import { createReferralLink } from '../createReferralLink';

export const useReferralLink = () => {
  const { userData } = useUserContext();

  const referralLink = useMemo(() => {
    if (userData?.Link_da_Loja) {
      return userData.Link_da_Loja;
    }
    const supplierName = userData?.Multivendor || '';
    return createReferralLink(supplierName);
  }, [userData?.Link_da_Loja, userData?.Multivendor]);

  return referralLink;
};
